<template>
    <v-dialog v-model="show" scrollable max-width="700" persistent no-click-animation>
        <v-card>
            <v-card-title primary-title class="headline grey lighten-2 pa-0">
                <v-layout row justify-space-between align-center>
                    <div class="ml-3">{{ $t('massCalling') | capitalizeAll }}</div>
                    <v-btn flat icon @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text style="height: 500px">
                <v-form v-model="formValid" ref="form">
                    <v-select
                        v-model="selectedVoiceProfile"
                        :items="voiceProfiles"
                        :label="$t('voiceProfile') | capitalize"
                        :rules="formRules.required"
                    >
                        <template v-slot:item="{ item }">
                            <v-tooltip v-if="item.voice.description" top>
                                <template v-slot:activator="{ on }">
                                    <img v-if="item.voice.description"
                                         src="/img/more_detail.svg"
                                         alt="icon-more-detail" style="width: 15px;">
                                </template>
                                <span>{{ item.voice.description }}</span>
                            </v-tooltip>
                            <span :class="item.voice.description ? 'pl-6' : ''">{{ item.voice.name }} - {{
                                    item.speed
                                }}</span>
                        </template>
                        <template v-slot:selection="{ item }" class="centerXY">
                            <img v-if="item.voice.description" :title="item.voice.description"
                                 src="/img/more_detail.svg"
                                 alt="icon-more-detail" style="width: 15px;">
                            <span :class="item.voice.description ? 'pl-6' : ''">{{ item.voice.name }} - {{
                                    item.speed
                                }}</span>
                        </template>
                    </v-select>
                    <div class="data-table">
                        <v-data-table
                            :headers="headers"
                            :items="customers"
                            :hide-actions="true"
                            :rows-per-page-items="[15, 30, 50, 100, 500]"
                        >
                            <template v-slot:items="props">
                                <td>{{ props.item.name }}</td>
                                <td>{{ getPrimaryPhoneNumber(props.item) }}</td>
                                <td>
                                <span class="row-actions">
                                    <v-icon @click="remove(props.item)" class="action-icon black--text">
                                        mdi-close
                                    </v-icon>
                                </span>
                                </td>
                            </template>
                        </v-data-table>
                    </div>
                </v-form>
            </v-card-text>
            <div>
                <v-divider></v-divider>
                <v-spacer></v-spacer>
                <v-card-actions class="flex-justify-content-end">
                    <v-btn color="primary" depressed
                           :disabled="dataLoading || !voiceProfiles.length || !customers.length"
                           @click="submit">
                        Call Now
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import CampaignService from '@/services/campaign.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import {mapState} from 'vuex'

export default {
    name: 'CampaignMassCalling',
    mixins: [
        FormMixin
    ],
    data() {
        return {
            show: false,
            dataLoading: false,
            formValid: false,
            customers: [],
            selectedVoiceProfile: {},
            voiceProfiles: [],
            headers: [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Telephone',
                    align: 'left',
                    sortable: true,
                    value: 'phone_number'
                },
                {
                    text: 'Action',
                    value: 'action',
                    sortable: false
                }
            ]
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    methods: {
        open(customers) {
            this.show = true
            this.resetModel()
            if (customers) {
                let filterCustomers = customers.filter(obj => obj.customStatus !== 'In Progress')
                this.selectionData = [...filterCustomers]
                this.customers = [...filterCustomers]
            }
            this.dataLoading = true
            CampaignService.VoiceSpeedService.search(this.campaign.id).then(res => {
                if (res.data.length) {
                    this.voiceProfiles = res.data
                    this.selectedVoiceProfile = this.voiceProfiles[0]
                    this.voiceProfiles.forEach(item => {
                        if (item.voice.default) {
                            this.selectedVoiceProfile = item
                        }
                    })
                }
                this.$nextTick().then(() => {
                    this.dataLoading = false
                    this.$refs.form.resetValidation()
                })
            })
        },
        close() {
            this.$emit('on-close', this.customers)
            this.resetModel()
            this.show = false
        },
        submit(event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                this.dataLoading = true
                let model = {
                    speed: this.selectedVoiceProfile.speed,
                    voice: this.selectedVoiceProfile.voice.voice,
                    customers: this.customers.reduce((ids, customer) => {
                        return ids = [...ids, customer.id]
                    }, [])
                }
                CampaignService.massCalling(this.campaign, model).then(res => {
                    this.$appService.toastSuccess(this.$t('Data successfully saved!'))
                    this.dataLoading = false
                    this.$emit('success')
                    this.close()
                }, err => {
                    this.dataLoading = false
                    this.$appService.handleRequestError(this.$t('Something went wrong !'))
                })
            } else {
                this.$refs.form.validate()
            }
        },
        remove(customer) {
            this.customers = [...this.customers.filter(item => item.id !== customer.id)]
        },
        resetModel() {
            this.customers = []
            this.voiceProfiles = []
            this.selectedVoiceProfile = {}
        },
        getPrimaryPhoneNumber(customer) {
            let min = 10000
            let primaryPhoneNumber = null
            for (let phoneNumber of customer.phone_numbers) {
                if (phoneNumber.priority < min) {
                    min = phoneNumber.priority
                    primaryPhoneNumber = phoneNumber.phone_number
                }
            }
            return primaryPhoneNumber
        }
    },
    beforeDestroy() {
        this.resetModel()
    }
}
</script>
<style scoped>
::v-deep .v-slider__thumb-label {
    border-radius: 50% 50% 0;
    transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);

}
</style>
